/**
 * Người dùng (Users) route family — Plans 7.2 decomposition.
 * All routes are direct children of _authenticated (authenticatedRoute).
 */
import { lazy } from "react";
import { createRoute } from "@tanstack/react-router";

import { authenticatedRoute } from "../__root.js";
import { withSuspense } from "../route-helpers.js";

// ── Lazy page imports ────────────────────────────────────────────────

const UsersPage = lazy(() => import("@/features/users").then((mod) => ({ default: mod.UsersPage })));
const UserDetailPage = lazy(() =>
  import("@/features/users/user-detail-page").then((mod) => ({ default: mod.UserDetailPage })),
);
const SessionsPage = lazy(() =>
  import("@/features/sessions").then((mod) => ({ default: mod.SessionsPage })),
);
const SessionDetailPage = lazy(() =>
  import("@/features/sessions/session-detail-page").then((mod) => ({ default: mod.SessionDetailPage })),
);

// ── Routes ───────────────────────────────────────────────────────────

const usersRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/nguoi-dung",
  component: withSuspense(UsersPage),
});

const userDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/nguoi-dung/$publicId",
  component: withSuspense(UserDetailPage),
});

const sessionsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/nguoi-dung/phien",
  component: withSuspense(SessionsPage),
});

const sessionDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/nguoi-dung/phien/$sessionId",
  component: withSuspense(SessionDetailPage),
});

export const nguoiDungRoutes = [
  usersRoute,
  userDetailRoute,
  sessionsRoute,
  sessionDetailRoute,
];
